const CustomerTypeEnum = Object.freeze({
    //APPARTMENT: 1,
    HOUSE: 2,
    COMPANY: 3
  });
  
  export default CustomerTypeEnum;